// extracted by mini-css-extract-plugin
export default {"studia-error-container__container":"StudioErrorsContainer_studia-error-container__container__MeWKP"};